import { createAction, props } from '@ngrx/store';

import { MediaListEntity } from '../components/media-list/media-list.entity';
import { MediaType } from '../domain/media.domain';

export enum MediaActions {
	InitMediaList = '[Media] get media list',
	RefreshMediaList = '[BE][Media] refresh media list',
	FetchMediaListSuccess = '[BE][Media] fetch media list success',
	FetchMediaListFail = '[BE][Media] fetch media list fail',
	NavigateToMediaCreateRoute = '[Media] navigate to media create route',
	NavigateToMediaRoute = '[Media] navigate to media route',
	ToggleMediaStatus = '[Media] toggle media status',
	OpenDeleteConfirmationPopup = '[Media] open delete confirm popup',
	DeleteMedia = '[Media] delete media',
	BulkDeleteMedias = '[Media] delete many medias',
	DeleteMediaSuccess = '[BE][Media] delete media success',
	DeleteMediaFail = '[BE][Media] delete media fail',
	DuplicateMedia = '[Media] duplicate media',
	DuplicateMediaSuccess = '[BE][Media] duplicate media success',
	DuplicateMediaFail = '[BE][Media] duplicate media fail',
}

export const initMediaList = createAction(MediaActions.InitMediaList);

export const refreshMediaList = createAction(MediaActions.RefreshMediaList);

export const fetchMediaListSuccess = createAction(
	MediaActions.FetchMediaListSuccess,
	props<{ mediaList: MediaListEntity }>()
);

export const fetchMediaListFail = createAction(
	MediaActions.FetchMediaListFail,
	props<{ error: unknown }>()
);

export const navigateToMediaCreate = createAction(
	MediaActions.NavigateToMediaCreateRoute
);

export const navigateToMedia = createAction(
	MediaActions.NavigateToMediaRoute,
	props<{
		id: number;
		mediaType: MediaType;
		goToVisuTab: boolean;
	}>()
);

export const toggleMediaStatus = createAction(
	MediaActions.ToggleMediaStatus,
	props<{ mediaId: number; mediaType: MediaType }>()
);

export const openDeleteConfirmationPopup = createAction(
	MediaActions.OpenDeleteConfirmationPopup,
	props<{
		mediaId: Array<number>;
		mediaLabel: string;
		mediaType: Array<MediaType>;
	}>()
);

export const deleteMedia = createAction(
	MediaActions.DeleteMedia,
	props<{ mediaId: number; mediaType: MediaType }>()
);

export const bulkDeleteMedias = createAction(
	MediaActions.BulkDeleteMedias,
	props<{ mediaIds: Array<number> }>()
);

export const deleteMediaSuccess = createAction(MediaActions.DeleteMediaSuccess);

export const deleteMediaFail = createAction(
	MediaActions.DeleteMediaFail,
	props<{ error: unknown }>()
);

export const duplicateMedia = createAction(
	MediaActions.DuplicateMedia,
	props<{ mediaId: number; mediaType: MediaType }>()
);

export const duplicateMediaSuccess = createAction(
	MediaActions.DuplicateMediaSuccess,
	props<{ id: number; mediaType: MediaType }>()
);

export const duplicateMediaFail = createAction(
	MediaActions.DuplicateMediaFail,
	props<{ error: unknown }>()
);
